import { Box, Drawer, Typography, Button } from '@mui/material';
import { useState } from 'react';
import { tss } from 'tss-react/mui';
import { CookieSettingsModal } from './CookieSettingsModal';
import Cookies from 'js-cookie';
import { allCookiesSelected, cookieState, noCookiesSelected } from './cookies';
import { useCookies } from './CookiesProvider';

export const CookiesFooter: React.FC = () => {
  const { classes } = useStyles();
  const [isCookiesSettingsModalOpen, setCookiesSettingsModalOpen] =
    useState(false);

  const { shouldShowCookies, setShouldShowCookies } = useCookies();

  const saveCookiesSettings = (cookies: cookieState) => {
    Object.entries(cookies).forEach(([key, value]) => {
      if (value && key !== 'cookie_necessary') {
        Cookies.set(key, '1');
      } else if (!(key === 'cookie_necessary')) {
        Cookies.remove(key);
      }
      Cookies.set('cookies_necessary', 'true');
      Cookies.set('cookies_settings', 'true');
      setShouldShowCookies(false);
    });
  };

  return (
    <Drawer
      open={shouldShowCookies}
      anchor="bottom"
      variant="persistent"
      PaperProps={{ sx: { px: 2, py: 1 } }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1
        }}
      >
        <Box sx={{ width: { xs: '100%', sm: '70%' } }}>
          <Typography variant="h4">We respect your privacy</Typography>
          <Typography variant="body1">
            We use cookies on our site to improve the experience for you. By
            clicking "Accept" you consent to our use of cookies.
          </Typography>
        </Box>
        <Box className={classes.buttonContainer}>
          <Button
            variant="outlined"
            onClick={() => setCookiesSettingsModalOpen(true)}
          >
            Preferences
          </Button>
          <Button
            onClick={() => saveCookiesSettings(noCookiesSelected)}
            variant="contained"
          >
            Decline
          </Button>
          <Button
            variant="contained"
            onClick={() => saveCookiesSettings(allCookiesSelected)}
          >
            Accept
          </Button>
        </Box>
      </Box>
      <CookieSettingsModal
        open={isCookiesSettingsModalOpen}
        handleCookieSave={(cookies: cookieState) => {
          saveCookiesSettings(cookies);
          setCookiesSettingsModalOpen(false);
        }}
        onClose={() => setCookiesSettingsModalOpen(false)}
      />
    </Drawer>
  );
};

const useStyles = tss.create(({ theme }) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    gap: theme.spacing(1)
  }
}));
